// extracted by mini-css-extract-plugin
export default {"container":"r7lSD","title":"A0PQ5","content":"shCan"};